import Button from "components/buttons/Button"
import useTranslations from "hooks/useTranslations"
import cc from "classcat"

type ContactButtonProps = {
  bgStyle?:
    | "primary"
    | "light"
    | "dark"
    | "blue"
    | "yellow"
    | "cadetblue"
    | "black"
    | "green"
  left?: boolean
}

const ContactButton = ({ bgStyle = "primary", left }: ContactButtonProps) => {
  const { schoolWebinarRequestLinkText } = useTranslations()
  return (
    <div className={cc(["max-w-xs", left ? "" : "mx-auto"])}>
      <Button
        bgStyle={bgStyle}
        label={schoolWebinarRequestLinkText}
        link="#contact"
      />
    </div>
  )
}

export default ContactButton
